var map = {
	"./arrow-down.svg": "c874",
	"./arrow-right.svg": "cd8c",
	"./arrow-up.svg": "a3f8",
	"./chevron.svg": "079d",
	"./close.svg": "8b1b",
	"./compass.svg": "7259",
	"./copy.svg": "8aac",
	"./email.svg": "43be",
	"./exit-link.svg": "2e53",
	"./facebook.svg": "8485",
	"./instagram.svg": "bd6c",
	"./kind.svg": "8ad3",
	"./linkedin.svg": "9ed9",
	"./play.svg": "dab1",
	"./search.svg": "d103",
	"./twitter.svg": "acf9",
	"./water-pollution.svg": "5941",
	"./wetlands.svg": "2f35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";